import { render, staticRenderFns } from "./AssetModal.vue?vue&type=template&id=b4fa70c8&scoped=true"
import script from "./AssetModal.vue?vue&type=script&lang=js"
export * from "./AssetModal.vue?vue&type=script&lang=js"
import style0 from "./AssetModal.vue?vue&type=style&index=0&id=b4fa70c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fa70c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4fa70c8')) {
      api.createRecord('b4fa70c8', component.options)
    } else {
      api.reload('b4fa70c8', component.options)
    }
    module.hot.accept("./AssetModal.vue?vue&type=template&id=b4fa70c8&scoped=true", function () {
      api.rerender('b4fa70c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modals/AssetModal.vue"
export default component.exports